// resources/js/src/services/profile.api.ts
import { request, requestFull } from "./api";

export type ProfileState =
  | "owner"
  | "friend"
  | "pending_outgoing"
  | "pending_incoming"
  | "blocked_by_me"
  | "blocked_by_them"
  | "stranger"
  | "not_found"
  | "banned";

export type UserProfile = {
  id: string;
  name: string;
  avatarUrl: string | null;
  coverUrl: string | null;
  bio: string | null;
  friendCount: number;
  joinedAt: string | null;
};

export type ProfileData = {
  state: ProfileState;
  user: UserProfile;
};

export type ProfileFriend = {
  id: string;
  name: string;
  avatarUrl: string | null;
  mutualFriends: number;
};

export type ProfilePhoto = {
  id: number;
  url: string;
};

export type FriendsPage = {
  data: ProfileFriend[];
  meta: {
    next_cursor: string | null;
    has_more: boolean;
    per_page: number;
  };
};

export type PhotosPage = {
  data: ProfilePhoto[];
  meta: {
    next_cursor: string | null;
    has_more: boolean;
    per_page: number;
  };
};

export const profileApi = {
  show: (id: string) =>
    request<ProfileData>("GET", `/community/users/${id}`),

  getFriends: (id: string, cursor?: string | null, perPage = 9) => {
    const params = new URLSearchParams();
    params.set("per_page", String(perPage));
    if (cursor) params.set("cursor", cursor);
    return requestFull<ProfileFriend[]>(
      "GET",
      `/community/users/${id}/friends?${params.toString()}`
    ) as Promise<FriendsPage>;
  },

  getPhotos: (id: string, cursor?: string | null, perPage = 6) => {
    const params = new URLSearchParams();
    params.set("per_page", String(perPage));
    if (cursor) params.set("cursor", cursor);
    return requestFull<ProfilePhoto[]>(
      "GET",
      `/community/users/${id}/photos?${params.toString()}`
    ) as Promise<PhotosPage>;
  },
};